/**
 * 地图工具类
 */
import * as dd from 'dingtalk-jsapi'
import gdt from 'gdt-jsapi'
import Vue from 'vue'
import store from '@/store/index'
import { getWeiXinLocation } from '@/utils/weixin'
import { isWXEnv, isDDEnv, isGDTEnv } from './env'

/* 默认配置 */
const config = {
  key: '855a0d2320739f590ae452a2ca98800e',
  version: '1.4.14',
  plugins: ['AMap.Geolocation'],
  zoom: 14
}

export class Map {
  constructor ({ container }) {
    MapLoader().then(AMap => {
      this.container = document.getElementById(container)
      // console.dir('AMap', AMap)
      this.map = new AMap.Map(this.container, {
        // center: [117.000923, 36.675807],
        zoom: config.zoom
      })
      // 事件注册
      this._eventRegister(AMap)
    })
  }

  /* 将地图中心移动到点 */
  setCenter ({ longitude, latitude }) {
    MapLoader().then((AMap) => {
      this.map.setCenter(new AMap.LngLat(longitude, latitude))
    })
  }

  /* 获取当前位置 */
  getLocation () {
    return new Promise((resolve, reject) => {
      MapLoader().then((AMap) => {
        // debugger
        if (isWXEnv()) {
          // 使用微信定位
          console.log('微信定位')
          getWeiXinLocation().then((res) => {
            Vue.$vux.loading.hide()
            resolve(res)
          }).catch((error) => {
            console.log('微信定位失败', error)
            Vue.$vux.loading.hide()
            Vue.$vux.toast.show({ text: '微信定位失败', type: 'cancel' })
          })
        } else if (isDDEnv()) {
          // 使用钉钉的api定位
          Vue.$vux.loading.show({ text: '定位中' })
          dd.device.geolocation.get({
            targetAccuracy: 200,
            coordinate: 1,
            withReGeocode: false,
            useCache: false,
            onSuccess  (result) {
              resolve({ longitude: result.longitude, latitude: result.latitude })
              Vue.$vux.loading.hide()
            },
            onFail (err) {
              console.log('钉钉定位失败 :>> ', err)
              Vue.$vux.toast.show({ text: '钉钉定位失败', type: 'cancel' })
              Vue.$vux.loading.hide()
            }
          })
        } else if (isGDTEnv()) {
          // 使用政务钉钉或浙政钉的api定位
          Vue.$vux.loading.show({ text: '定位中' })
          gdt.getGeolocation({
            targetAccuracy: 200,
            coordinate: 1,
            withReGeocode: false,
            useCache: false
          }).then(result => {
            resolve({ longitude: result.longitude, latitude: result.latitude })
            Vue.$vux.loading.hide()
          }).catch(err => {
            console.log('政务钉钉或浙政钉定位失败 :>> ', err)
            Vue.$vux.toast.show({ text: '政务钉钉或浙政钉定位失败', type: 'cancel' })
            Vue.$vux.loading.hide()
          })
        } else {
          Vue.$vux.toast.show({ text: '签到功能只能在钉钉或者微信中使用', type: 'cancel' })
        }
      })
    })
  }

  /* 添加点标记 */
  addMarker ({ marker, position }) {
    return new Promise((resolve, reject) => {
      MapLoader().then((AMap) => {
        if (marker.marker) {
          // 移除已存在的点
          this.map.remove(marker.marker)
        }
        // 添加新的点
        let newMarker = new AMap.Marker({
          position: new AMap.LngLat(position.longitude, position.latitude),
          icon: marker.icon,
          // content: marker.content || '',
          offset: new AMap.Pixel(-15, -15)
        })
        newMarker.setMap(this.map)
        // this.map.add(newMarker)
        resolve(newMarker)
      })
    })
  }

  /* 添加圆形标记 */
  addCircle ({ circle, position }) {
    return new Promise((resolve, reject) => {
      MapLoader().then((AMap) => {
        if (circle.circle) {
          // 移除已存在的点
          this.map.remove(circle.circle)
        }
        let newCircle = new AMap.Circle({
          center: new AMap.LngLat(position.longitude, position.latitude), // 圆心位置
          radius: circle.radius || 600,
          borderWeight: circle.borderWeight || 3,
          strokeColor: circle.strokeColor || '#409eff',
          strokeWeight: circle.strokeWeight || 2,
          strokeOpacity: circle.strokeOpacity || 1,
          fillColor: circle.fillColor || '#409eff',
          fillOpacity: circle.fillOpacity || 0.1,
          zIndex: 50
        })
        // 添加点
        newCircle.setMap(this.map)
        // this.map.add(newCircleMarker)
        resolve(newCircle)
      })
    })
  }

  /* 计算两点的距离 */
  getDistance ({ from, to }) {
    return new Promise((resolve, reject) => {
      MapLoader().then((AMap) => {
        let distance = AMap.GeometryUtil.distance([from.longitude, from.latitude], [to.longitude, to.latitude])
        resolve(distance)
      })
    })
  }

  /* 注册定位功能 */
  _registerLocation (AMap) {
    this.map.plugin('AMap.Geolocation', () => {
      this.geolocation = new AMap.Geolocation({
        enableHighAccuracy: true, // 是否使用高精度定位，默认:true
        timeout: 10000, // 超过10秒后停止定位，默认：无穷大
        maximumAge: 0, // 定位结果缓存0毫秒，默认：0
        convert: true, // 自动偏移坐标，偏移后的坐标为高德坐标，默认：true
        showButton: true, // 显示定位按钮，默认：true
        buttonPosition: 'LB', // 定位按钮停靠位置，默认：'LB'，左下角
        buttonOffset: new AMap.Pixel(10, 20), // 定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
        showMarker: true, // 定位成功后在定位到的位置显示点标记，默认：true
        showCircle: true, // 定位成功后用圆圈表示定位精度范围，默认：true
        panToLocation: true, // 定位成功后将定位到的位置作为地图中心点，默认：true
        zoomToAccuracy: true // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
      })
      // 添加到地图控件（需要https支持）
      // this.map.addControl(this.geolocation)
      // 返回定位成功信息
      // AMap.event.addListener(this.geolocation, 'complete', (res) => { console.log('定位成功', res) })
      // 返回定位错误信息
      // AMap.event.addListener(this.geolocation, 'error', (error) => {})
    })
  }

  _eventRegister (AMap) {
    this._registerLocation(AMap)
  }

  // 根据地址返回经纬值
  getLonLat (address) {
    console.log('this3: ', this.AMap)
    return new Promise((resolve) => {
      MapLoader().then(AMap => {
        AMap.plugin('AMap.Geocoder', () => {
          const geocoder = new AMap.Geocoder({})
          geocoder.getLocation(address, (status, result) => {
            if (status === 'complete' && result.info === 'OK') {
              const { location } = result.geocodes[0]
              resolve([location.lng, location.lat])
            }
          })
        })
      })
    })
  }
}

/* 地图加载器 */
export const MapLoader = () => {
  return new Promise((resolve, reject) => {
    if (window.AMap) {
      resolve(window.AMap)
    } else {
      let { version, key } = store.getters.mapConfig
      let script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.src = `https://webapi.amap.com/maps?v=${version || config.version}&key=${key || config.key}&plugin=${config.plugins.join(',')}`
      script.onerror = reject
      script.onload = setTimeout(() => resolve(window.AMap), 1000)
      document.head.appendChild(script)
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/map.js